import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { MdEmail, MdPhone, MdPerson, MdMessage, MdSearch, MdKeyboardArrowDown } from 'react-icons/md';
import { submitToGoogleSheet } from '../../utils/helpers';
import classes from './Contact.module.scss';

const COUNTRIES = [
  { code: '+91', name: 'India', flag: '🇮🇳' },
  { code: '+1', name: 'United States', flag: '🇺🇸' },
  { code: '+44', name: 'United Kingdom', flag: '🇬🇧' },
  { code: '+61', name: 'Australia', flag: '🇦🇺' },
  { code: '+1', name: 'Canada', flag: '🇨🇦' },
  { code: '+971', name: 'UAE', flag: '🇦🇪' },
  { code: '+65', name: 'Singapore', flag: '🇸🇬' },
  { code: '+49', name: 'Germany', flag: '🇩🇪' },
  { code: '+33', name: 'France', flag: '🇫🇷' },
  { code: '+81', name: 'Japan', flag: '🇯🇵' },
  { code: '+86', name: 'China', flag: '🇨🇳' },
  { code: '+82', name: 'South Korea', flag: '🇰🇷' },
  { code: '+55', name: 'Brazil', flag: '🇧🇷' },
  { code: '+52', name: 'Mexico', flag: '🇲🇽' },
  { code: '+7', name: 'Russia', flag: '🇷🇺' },
  { code: '+34', name: 'Spain', flag: '🇪🇸' },
  { code: '+39', name: 'Italy', flag: '🇮🇹' },
  { code: '+31', name: 'Netherlands', flag: '🇳🇱' },
  { code: '+46', name: 'Sweden', flag: '🇸🇪' },
  { code: '+47', name: 'Norway', flag: '🇳🇴' },
  { code: '+45', name: 'Denmark', flag: '🇩🇰' },
  { code: '+358', name: 'Finland', flag: '🇫🇮' },
  { code: '+41', name: 'Switzerland', flag: '🇨🇭' },
  { code: '+43', name: 'Austria', flag: '🇦🇹' },
  { code: '+32', name: 'Belgium', flag: '🇧🇪' },
  { code: '+351', name: 'Portugal', flag: '🇵🇹' },
  { code: '+48', name: 'Poland', flag: '🇵🇱' },
  { code: '+90', name: 'Turkey', flag: '🇹🇷' },
  { code: '+966', name: 'Saudi Arabia', flag: '🇸🇦' },
  { code: '+20', name: 'Egypt', flag: '🇪🇬' },
  { code: '+27', name: 'South Africa', flag: '🇿🇦' },
  { code: '+234', name: 'Nigeria', flag: '🇳🇬' },
  { code: '+254', name: 'Kenya', flag: '🇰🇪' },
  { code: '+60', name: 'Malaysia', flag: '🇲🇾' },
  { code: '+62', name: 'Indonesia', flag: '🇮🇩' },
  { code: '+63', name: 'Philippines', flag: '🇵🇭' },
  { code: '+66', name: 'Thailand', flag: '🇹🇭' },
  { code: '+84', name: 'Vietnam', flag: '🇻🇳' },
  { code: '+92', name: 'Pakistan', flag: '🇵🇰' },
  { code: '+880', name: 'Bangladesh', flag: '🇧🇩' },
  { code: '+94', name: 'Sri Lanka', flag: '🇱🇰' },
  { code: '+977', name: 'Nepal', flag: '🇳🇵' },
  { code: '+64', name: 'New Zealand', flag: '🇳🇿' },
  { code: '+353', name: 'Ireland', flag: '🇮🇪' },
  { code: '+972', name: 'Israel', flag: '🇮🇱' },
  { code: '+98', name: 'Iran', flag: '🇮🇷' },
  { code: '+974', name: 'Qatar', flag: '🇶🇦' },
  { code: '+965', name: 'Kuwait', flag: '🇰🇼' },
  { code: '+973', name: 'Bahrain', flag: '🇧🇭' },
  { code: '+968', name: 'Oman', flag: '🇴🇲' },
  { code: '+212', name: 'Morocco', flag: '🇲🇦' },
  { code: '+213', name: 'Algeria', flag: '🇩🇿' },
  { code: '+216', name: 'Tunisia', flag: '🇹🇳' },
  { code: '+233', name: 'Ghana', flag: '🇬🇭' },
  { code: '+251', name: 'Ethiopia', flag: '🇪🇹' },
  { code: '+255', name: 'Tanzania', flag: '🇹🇿' },
  { code: '+54', name: 'Argentina', flag: '🇦🇷' },
  { code: '+56', name: 'Chile', flag: '🇨🇱' },
  { code: '+57', name: 'Colombia', flag: '🇨🇴' },
  { code: '+51', name: 'Peru', flag: '🇵🇪' },
  { code: '+380', name: 'Ukraine', flag: '🇺🇦' },
  { code: '+30', name: 'Greece', flag: '🇬🇷' },
  { code: '+420', name: 'Czech Republic', flag: '🇨🇿' },
  { code: '+36', name: 'Hungary', flag: '🇭🇺' },
  { code: '+40', name: 'Romania', flag: '🇷🇴' },
];

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    message: '',
  });
  const [countryCode, setCountryCode] = useState(COUNTRIES[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0, width: 0 });
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [alreadySubmitted, setAlreadySubmitted] = useState(() => !!localStorage.getItem('lead_submitted'));

  const triggerRef = useRef(null);
  const selectorRef = useRef(null);
  const dropdownMenuRef = useRef(null);
  const searchRef = useRef(null);

  // Recalculate dropdown position whenever it opens
  const openDropdown = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownPos({
        top: rect.bottom + 6,
        left: rect.left,
        width: Math.max(rect.width, 280),
      });
    }
    setDropdownOpen(true);
  };

  // Close on outside click (works with portal)
  useEffect(() => {
    const handleClickOutside = (e) => {
      const insideSelector = selectorRef.current?.contains(e.target);
      const insideMenu = dropdownMenuRef.current?.contains(e.target);
      if (!insideSelector && !insideMenu) {
        setDropdownOpen(false);
        setSearchQuery('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Close on scroll so the fixed menu doesn't drift
  useEffect(() => {
    if (!dropdownOpen) return;
    const handleScroll = () => {
      setDropdownOpen(false);
      setSearchQuery('');
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [dropdownOpen]);

  // Auto-focus search when dropdown opens
  useEffect(() => {
    if (dropdownOpen && searchRef.current) {
      searchRef.current.focus();
    }
  }, [dropdownOpen]);

  const filteredCountries = COUNTRIES.filter(
    (c) =>
      c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      c.code.includes(searchQuery)
  );

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCountrySelect = (country) => {
    setCountryCode(country);
    setDropdownOpen(false);
    setSearchQuery('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Block if already submitted (double-safety in case button wasn't disabled)
    if (alreadySubmitted) return;

    setLoading(true);
    try {
      await submitToGoogleSheet({
        ...formData,
        phoneNumber: `(${countryCode.code}) ${formData.phoneNumber}`,
      });

      // Mark as submitted — blocks re-submission in this session AND future sessions
      localStorage.setItem('lead_submitted', 'true');
      setAlreadySubmitted(true);

      // Fire Google Ads conversion event (guarded by the same flag above)
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
          send_to: 'AW-XXXXXXXXXX/XXXXXXXXXXXX', // Replace with your Google Ads Conversion ID/Label
        });
      }

      if (typeof window.gtag_report_conversion === 'function') {
        window.gtag_report_conversion();
      }
      alert('Thank you! We will get back to you soon.');
      setFormData({ name: '', email: '', phoneNumber: '', message: '' });
    } catch (error) {
      console.error('Form submission error:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Dropdown rendered via portal to escape overflow:hidden on .contact
  const dropdownPortal = dropdownOpen
    ? ReactDOM.createPortal(
      <div
        ref={dropdownMenuRef}
        className={classes.dropdownMenu}
        style={{
          position: 'fixed',
          top: dropdownPos.top,
          left: dropdownPos.left,
          width: 280,
        }}
      >
        <div className={classes.searchWrapper}>
          <MdSearch className={classes.searchIcon} />
          <input
            ref={searchRef}
            type="text"
            placeholder="Search country..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className={classes.searchInput}
          />
        </div>
        <ul className={classes.countryList} role="listbox">
          {filteredCountries.length > 0 ? (
            filteredCountries.map((country, i) => (
              <li
                key={`${country.code}-${country.name}-${i}`}
                role="option"
                aria-selected={countryCode.name === country.name}
                className={`${classes.countryItem} ${countryCode.name === country.name ? classes.countryItemActive : ''
                  }`}
                onMouseDown={() => handleCountrySelect(country)}
              >
                <span className={classes.itemFlag}>{country.flag}</span>
                <span className={classes.countryName}>{country.name}</span>
                <span className={classes.countryCode}>{country.code}</span>
              </li>
            ))
          ) : (
            <li className={classes.noResults}>No results found</li>
          )}
        </ul>
      </div>,
      document.body
    )
    : null;

  return (
    <section id="contact" className={classes.contact}>
      <div className={classes.container}>
        <div className={classes.header}>
          <span className={classes.badge}>Get In Touch</span>
          <h2 className={classes.title}>
            Let's Build <span className={classes.gradient}>Something Great</span>
          </h2>
        </div>

        <div className={classes.content}>
          <form className={classes.form} onSubmit={handleSubmit}>
            <div className={classes.formRow}>
              <div className={classes.formGroup}>
                <label htmlFor="name">
                  <MdPerson className={classes.labelIcon} />
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                  className={classes.premiumInput}
                />
              </div>

              <div className={classes.formGroup}>
                <label htmlFor="email">
                  <MdEmail className={classes.labelIcon} />
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="your.email@company.com"
                  className={classes.premiumInput}
                />
              </div>
            </div>

            {/* Phone Number with Country Code */}
            <div className={classes.formGroup}>
              <label>
                <MdPhone className={classes.labelIcon} />
                Phone Number
              </label>
              <div className={classes.phoneWrapper}>
                {/* Country selector trigger */}
                <div className={classes.countrySelector} ref={selectorRef}>
                  <button
                    ref={triggerRef}
                    type="button"
                    className={classes.dropdownTrigger}
                    onClick={() => (dropdownOpen ? setDropdownOpen(false) : openDropdown())}
                    aria-expanded={dropdownOpen}
                    aria-haspopup="listbox"
                  >
                    <span className={classes.flag}>{countryCode.flag}</span>
                    <span className={classes.dialCode}>{countryCode.code}</span>
                    <MdKeyboardArrowDown
                      className={`${classes.chevron} ${dropdownOpen ? classes.chevronOpen : ''}`}
                    />
                  </button>
                </div>

                {/* Phone number input */}
                <input
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                  placeholder="98765 43210"
                  className={classes.phoneInput}
                />
              </div>
            </div>

            <div className={classes.formGroup}>
              <label htmlFor="message">
                <MdMessage className={classes.labelIcon} />
                Project Details
              </label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                placeholder="Tell us about your project vision, goals, and requirements..."
                className={classes.premiumTextarea}
              ></textarea>
            </div>

            {alreadySubmitted && (
              <p className={classes.alreadySubmittedMsg}>
                ✓ Your inquiry has already been submitted. We'll be in touch soon!
              </p>
            )}

            <button
              type="submit"
              className={classes.submitBtn}
              disabled={loading || alreadySubmitted}
            >
              <span className={classes.btnText}>
                {loading && <span className={classes.spinner} />}
                {alreadySubmitted ? 'Already Submitted' : loading ? 'Sending...' : 'Send Message'}
              </span>
              <div className={classes.btnGlow}></div>
            </button>
          </form>
        </div>
      </div>

      {/* Portal: rendered at document.body to escape overflow:hidden */}
      {dropdownPortal}
    </section>
  );
};

export default Contact;
